export const environment = {
  production: false,
  apiUrl: "https://hc-ecom-api.broadlanddigital.co.uk/"
};
